import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding: 0.75rem 0;
  align-items: center;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`;
